import React from 'react';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { infoPedido } from '../../../apis/servicePedidoConsulta';
import { CabecalhoPedido } from '../../CabecalhoDetalhesPedido';
import { Typography, Accordion, AccordionDetails, AccordionSummary, makeStyles, createStyles, Theme } from "@material-ui/core";
import ReactLoading from 'react-loading';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { TabelaListaItensConsultaPedidos } from "../../TabelaListaItensConsultaPedidos";
import { usePedidos } from '../../../../../contexts/Pedidos';
import { useHistory } from 'react-router-dom';
import { ArrayItensPedido, dadosPedido } from '../../../interfaces';
import { Button } from '../../../../../themes/components/Button';
import { useModals } from '../../../../../contexts/Modals';
import { useRelatorios } from '../../../../../contexts/Relatorios';

interface propsModalHistoricoPedido {
    numPed: number;
    codEmp: string;
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

let emptPed = {
    cidcli: '',
    codcli: '',
    codcpg: '',
    codctn: '',
    codemp: '',
    codfil: '',
    codfpg: '',
    codgre: '',
    codmot: '',
    codrep: '',
    datapr: '',
    datemi: '',
    datger: '',
    datprv: '',
    descpg: '',
    desfpg: '',
    desmot: '',
    endcli: '',
    horapr: '',
    horger: '',
    nomcli: '',
    nomrep: '',
    nomsup: '',
    numped: '',
    obsped: '',
    pedcrt: '',
    pedori: '',
    przmed: '',
    qtdori: '',
    repsup: '',
    sigufs: '',
    sitped: '',
    tnspro: '',
    vlrori: ''
};


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '97%',
            marginLeft: '1em'
        },
    }),
);


export function ModalDetalhePedido(props: propsModalHistoricoPedido) {
    let history = useHistory();
    const { gerarRelatorio } = useRelatorios();
    const { buscarItensPedido } = usePedidos();
    const { mostrarInfoOK } = useModals();
    const [dadosPedido, setDadosPedido] = useState<dadosPedido>();
    const [itensPedido, setItensPedido] = useState<ArrayItensPedido>();
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingItens, setLoadingItens] = useState<boolean>(false);
    const [danfeSolicitada, setDanfeSolicitada] = useState<boolean>(false);
    const classes = useStyles();

    useEffect(() => {
        async function getDadosPedido() {
            await infoPedido(props.numPed, props.codEmp, sessionStorage.getItem("userlogin"), sessionStorage.getItem("logid"))
                .then(res => {
                    setDadosPedido(res[0]);
                    setLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setLoading(false);
                })
        }
        setDadosPedido(emptPed);
        if (props.showModal === true) {
            setLoading(true);
            if (props.numPed !== 0) {
                getDadosPedido();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.showModal]);

    function buscarItens() {
        async function getDadosItensPedido() {         

            await buscarItensPedido(props.numPed.toString(), props.codEmp, history)
                .then(res => {
                    setItensPedido(res);
                    setLoadingItens(false);
                })
                .catch(err => {
                    console.log(err);
                    setLoadingItens(false);
                })
        }
        if (itensPedido === undefined) {
            setLoadingItens(true);
            getDadosItensPedido();
        }
    }


    async function handleCopiarPedido() {
        //mostrarInfoOK("Função em manutenção!", "Atualização em breve!");
        history.push({
            pathname: `${process.env.PUBLIC_URL}/pedidos/novo`,
            state: {
                from: '/pedidos/consultar/modal',
                Pedido: dadosPedido
            }
        });
    }

    function solicitarRelatorio() {
        if(dadosPedido !== undefined){
            let objParams: any = [];
            objParams.push({ nome: "NUMPED", valor: dadosPedido.numped});
            objParams.push({ nome: "CODEMP", valor: props.codEmp});
            gerarRelatorio("RFNF800", JSON.parse(JSON.stringify(objParams)), history)
            setDanfeSolicitada(true);
            mostrarInfoOK("A DANFE está sendo gerada, receberá uma notificação quando terminar!");
        }
    }

    function closeModal(){
        props.setShowModal(false);
        setDanfeSolicitada(false);
        setItensPedido(undefined);
    }

    return (
        <Modal
            show={props.showModal}
            onHide={() => closeModal()}
            dialogClassName="modal-90w"
            animation={true}
            centered={true}
            size='xl'
        >
            {props.showModal === true &&
                <>
                    <Modal.Header closeButton className={props.codEmp == "2" ? "modal-header-detalhe-pedido": props.codEmp == "4" ? "modal-header-detalhe-pedido-1" : "modal-header-detalhe-pedido"}>
                        <Modal.Title className="detalhe-pedido-titulo-modal">
                            {loading ? <ReactLoading type={"bars"} color={"white"} height={30} width={50} className="detalhe-pedido-titulo-loading" /> :
                                <Typography className="detalhe-pedido-texto-titulo">Detalhes do Pedido {dadosPedido?.numped}</Typography>
                            }
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {loading ? <></> :
                            <div style={{ overflowX: 'scroll' }}>
                                <CabecalhoPedido dadosPedido={dadosPedido} />
                                <div className={classes.root}>
                                    <Accordion className={"tabela-itens-consulta-pedidos-modal"}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            onClick={() => buscarItens()}
                                        >
                                            <Typography className={"cabecalho-detalhe-form-title show-itens-pedido"}>Itens do Pedido</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {loadingItens ?
                                                <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} className="detalhe-pedido-titulo-loading" />
                                                :
                                                <TabelaListaItensConsultaPedidos allowSelectitem={false} listaItens={itensPedido || []} />
                                            }
                                        </AccordionDetails>
                                    </Accordion>
                                    <div className="modal-additens-footer-itens-area">
                                        <div className="modal-additens-footer-info-area">
                                        </div>
                                        <div className="modal-additens-footer-addbotoes-area">
                                            {parseFloat(String(dadosPedido?.codmot)) >= 10 && parseFloat(String(dadosPedido?.codmot)) <= 13  ? <Button onClick={() => solicitarRelatorio()} classBtn={"btn-footer-novo-pedido color-default"} disabled={danfeSolicitada}>DANFE</Button> : <></> }
                                            <Button onClick={() => handleCopiarPedido()} classBtn={"btn-footer-novo-pedido color-default"}>Copiar Pedido</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Modal.Body>
                </>
            }
        </Modal>
    );
}